export enum FeatureFlag {
  RSS = 'resto365-rss',
  MASTER_PRODUCT_LIST = 'resto-master-product-list',
  FRANCHISE_HUB = 'resto365-franchisee',
  ORDER_MANAGEMENT = 'order-management',
  CATERING_TIME_SLOTS = 'resto365-catering-time-slots',
  ADMIN_TOOLS = 'resto365-admin-tools',
  NRO_INSIGHT = 'resto365-nro-insight',
  KITCHEN_MANAGEMENT = 'resto365-kitchen-management',
  EON_REPORTING = 'resto365-eon-reporting',
  CASH_COUNT = 'resto365-cash-count',
  WASTE_LOGGING = 'resto365-waste-logging',

  /** Manager Prep (restaurant Prep tab) + gyg-prep-list chef app. Prep Configuration admin uses RBAC. */
  GYG_PREP_LIST = 'gyg-prep-list',
  RESTAURANT_INSIGHTS = 'resto365-insights',
  RESTO_COUPON_TOOLS = 'resto-coupon-tools',

  /** Network “Global Restaurant” dashboard tab (master list). */
  GLOBAL_RESTAURANT_DASHBOARD = 'global-restaurant-dashboard',

  /** Trading Hours Health tile on the network dashboard. */
  TH_HEALTH_WIDGET = 'th-health-widget',

  /** Training Planner (templates, reporting, restaurant training views). */
  DIGITAL_TRAINING_PLANNER = 'digital-training-planner',

  ASK_GYG = 'askgyg-bhyve',

  /** JSON array of role handles allowed to access Ask GYG (e.g. ["COC", "SCOC"]). */
  ASK_GYG_ROLES = 'askgyg-bhyve-roles',

  /** Order Details Drawer V2 (new UI). */
  OMS_ORDER_DETAILS_V2 = 'oms-order-details-v2'
}
